<template>
  <div>
    <div v-if="show">
        <!-- banner -->
        <CarouselHome :imgList="indexData.banner" />
        <!-- 公告 -->
        <Notice :notice="indexData.notice" />
        <!-- 新闻 -->
        <NewsInfomation :news="indexData.news" />
        <!-- 概况 -->
        <CompanyProfile :about="indexData.about" />
        <!-- 服务 -->
        <!-- <CooperationCustomer :services="indexData.services" /> -->
        <!-- 招聘采购 -->
        <RecruitProcure :procure-list="indexData.job" :recruit-list="indexData.purchase" />
        <!-- 证书 -->
        <Honor :honor="indexData.honor" />
        <!-- 业务领域 -->
        <Domain :business="indexData.business" />
        <!-- 优质项目 -->
        <Project :case-data="indexData.case" />
        <!-- 党建工作 -->
        <PartyWork :party="indexData.party" />

        <FooterBanner :footer-banner="indexData.footer_banner" />
    </div>
  </div>
</template>

<script>
import CarouselHome from "@/components/carousel_home/index";
import CooperationCustomer from "@/components/cooperation_customer/index";
import NewsInfomation from "@/components/news_infomation/index";
import CompanyProfile from "@/components/company_profile/index.vue";
import Notice from "@/components/notice/index.vue";
import RecruitProcure from "@/components/recruit_procure/index.vue";
import Honor from "@/components/honor/index.vue";
import Domain from "@/components/domain/index.vue";
import Project from "@/components/project/index.vue";
import PartyWork from "@/components/party_work/index.vue";
import FooterBanner from "@/components/footerBanner/index.vue";
export default {
  components: {
    CarouselHome,
    CooperationCustomer,
    NewsInfomation,
    CompanyProfile,
    Notice,
    RecruitProcure,
    Honor,
    Domain,
    Project,
    PartyWork,
    FooterBanner,
  },
  data() {
    return {
      show : false,
      indexData: {},
    };
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      this.$request({
        url: "/index",
        method: "get",
      })
        .then((res) => {
          this.indexData = res.data;
          this.show = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.circle_img {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
    vertical-align: top;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin: 20px 0;
    }
  }
}
</style>
